import React, {useState} from 'react';
import styles from './index.module.css';
import {AccountSettings, Card, Flex, Heading, ThemeProvider, Alert} from '@aws-amplify/ui-react';
import components from "../../config/changePasswordOptions";

const ChangePassword = () => {
  const [showAlert, setShowAlert] = useState(false)

  const handleSuccess = () => {
    setShowAlert(true)
  }

  const theme = {
    name: "change-pass-theme",
    tokens: {
      colors: {
        font: {
          primary: {value: '#0d1a26'},
          secondary: {value: '#0d1a26'}
        }
      },
      fonts: {
        default: {
          variable: { value: 'Montserrat, sans-serif' },
          static: { value: 'Libre Baskerville, sans-serif' },
        },
      },
    }
  }

  return (
    <Flex
      id="change_password"
      gap="1rem"
      direction="column"
      alignItems="center"
      justifyContent="flex-start"
      templateColumns={{base: "1fr"}}
      className={styles.changePassWrapper}
    >
      {
        showAlert &&
        <Alert
          hasIcon
          variation="success"
          className={styles.successAlert}
          isDismissible
        >
          Password aggiornata correttamente
        </Alert>
      }
      <Card
        className={styles.formCard}
        variation="elevated"
      >
        <Heading
          level={2}
          className={styles.title}
        >
          Cambia password
        </Heading>
        <ThemeProvider theme={theme}>
          <AccountSettings.ChangePassword
            components={components}
            onSuccess={handleSuccess}
          />
        </ThemeProvider>
      </Card>
    </Flex>
  );
}

export default ChangePassword;